import {observable, action, autorun} from 'mobx';

let UI = observable({
  routes: ['/', '/texts', '/events', '/information'],
  currentPath: '/',
  scrollXPos: 0,
  page: 0,
  showNav: false,
  mouseX: 0,
  mouseY: 0,
  showArrow: null,
  isTouch: 'ontouchstart' in document.documentElement
})

window.addEventListener('mousemove', e => {
  UI.mouseX = e.clientX
  UI.mouseY = e.clientY

  if (e.clientY < 60) {
    UI.showNav = true
  } else {
    UI.showNav = false
  }
})

const onFirstTouch = () => {
  UI.isTouch = true
  window.removeEventListener('touchstart', onFirstTouch, false)
}

window.addEventListener('touchstart', onFirstTouch)

UI.updateCurrentPath = action(function (path) {
  UI.currentPath = path
})

autorun(() => {
  const path = UI.currentPath;

  const nextPage = (num) => {
    if (num || num === 0) {
      UI.page = num
    } else if (UI.page < 3) {
      UI.page++
    } else {
      UI.page = 0
    }
  }

  if (path === '/') {
    nextPage(0)
  } else if (path.indexOf('/texts') > -1) {
    nextPage(1)
  } else if (path.indexOf('/events') > -1) {
    nextPage(2)
  } else if (path === '/information') {
    nextPage(3)
  }
})

UI.updateScrollPosition = action(function (scrollX) {
  UI.scrollXPos = scrollX
})

UI.nextPage = action(function (num) {
  if (num || num === 0) {
    UI.page = num
  } else if (UI.page < 3) {
    UI.page++
  } else {
    UI.page = 0
  }
})

UI.showCursor = action(function (direction) {
  UI.showArrow = direction
})

export default UI



// WEBPACK FOOTER //
// ./app/javascript/packs/stores/UI.js